import { getUnixTime } from 'date-fns';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import { emitFieldChangedEvent } from 'app/events';
import { FIELD_DEPARTURE_DATE, FIELD_RETURN_DATE } from 'app/storage/fieldNames';
import { DateRangePicker } from 'app/components/date/DateRangePicker';
import {
  currentDateAtDepartureCitySelector,
  departureDateSelector,
  returnDateSelector,
  returnDateVisibleSelector,
  localeSelector,
} from 'app/store/selectors';
import { StoreState } from 'app/models/types';
import { SearchMaskMountOptions } from '@webc/meeseeks-ui-sdk';
import { WithOptions } from '../WithOptions';
import { requestSearch } from 'app/store/thunk/general/requestSearchThunk';
import { AppDispatch } from 'app/hooks/appHooks';
import { hideReturnDate, setDate } from 'app/store/thunk/date';

type OwnProps = ReturnType<typeof mapStateToProps> & { options: SearchMaskMountOptions };

const mapStateToProps = (state: StoreState) => ({
  departureDate: departureDateSelector(state),
  minDepartureDate: currentDateAtDepartureCitySelector(state),
  returnDate: returnDateSelector(state),
  returnDateVisible: returnDateVisibleSelector(state),
  locale: localeSelector(state),
});

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: OwnProps) => () => {
  const callRequestSearch = () => dispatch(requestSearch({}));

  return {
    onDepartureDateChange: (date: Date) => {
      dispatch(setDate({ date: getUnixTime(date) }));
      emitFieldChangedEvent(FIELD_DEPARTURE_DATE, format(date, 'dd.MM.yyyy'));

      if (ownProps.options.autoUpdate) {
        callRequestSearch();
      }
    },
    onReturnDateChange: (date: Date) => {
      dispatch(setDate({ date: getUnixTime(date), isReturn: true }));
      emitFieldChangedEvent(FIELD_RETURN_DATE, format(date, 'dd.MM.yyyy'));

      if (ownProps.options.autoUpdate) {
        callRequestSearch();
      }
    },
    onHideReturnDate: () => {
      dispatch(hideReturnDate());

      if (ownProps.options.autoUpdate) {
        callRequestSearch();
      }
    },
  };
};

export default WithOptions(connect(mapStateToProps, mapDispatchToProps)(DateRangePicker));
